const cfg = (typeof window !== 'undefined' && window.__ORYX_CONFIG__) ? window.__ORYX_CONFIG__ : {};

export const runtimeConfig = {
  apiUri: cfg.apiUri || process.env.VUE_APP_API_URI || '',
  theme: {
    primary: (cfg.theme && cfg.theme.primary) || process.env.VUE_APP_PRIMARY_COLOR || '#12121e',
    secondary: (cfg.theme && cfg.theme.secondary) || process.env.VUE_APP_SECONDARY_COLOR || '#b39246',
  }
};